import { render, staticRenderFns } from "./ModificaCliente.vue?vue&type=template&id=a892a2b4&lang=pug&"
import script from "./ModificaCliente.vue?vue&type=script&lang=js&"
export * from "./ModificaCliente.vue?vue&type=script&lang=js&"
import style0 from "./ModificaCliente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports